// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8603dea","239":"06d1d75e","455":"4d2e18d4"}[chunkId] + ".chunk.js";
};